import React from "react";

export default function PrivacyPolicy() {
  return (
    <section className="bg-gray-50 py-16 pt-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* Page Header */}
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-h1 font-bold text-trogoBlue">
            Privacy Policy
          </h1>
          <p className="text-gray-600 mt-3">
            Your trust & safety matter to us. This policy explains how
            To Goods Draft Private Limited manages data, responsibilities,
            security and user protection.
          </p>
        </div>

        {/* Policy Intro Banner */}
        <div className="mt-10 bg-white border rounded-3xl shadow-md p-8">
          <p className="text-gray-700 leading-relaxed">
            To Goods Draft Private Limited is committed to providing secure,
            verified and reliable transport services to customers while ensuring 
            maximum privacy, data protection and compliance with legal standards.
          </p>
        </div>

        {/* Authorities Section */}
        <div className="mt-14">
          <h2 className="text-2xl font-bold text-trogoBlue">
            1️⃣ Authorities
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mt-6">
            
            <div className="bg-white rounded-2xl shadow p-6 border">
              <h3 className="text-xl font-semibold text-trogoOrange">Company Authority</h3>
              <p className="text-gray-700 mt-3">
                The company holds complete authority to define policies,
                manage platform operations, register vehicles & drivers,
                enforce rules and protect customer data.
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow p-6 border">
              <h3 className="text-xl font-semibold text-trogoOrange">
                Legal Authority
              </h3>
              <p className="text-gray-700 mt-3">
                Any policy violation will be treated as a punishable offense
                under the Indian Penal Code (IPC) and necessary actions will
                be taken.
              </p>
            </div>

          </div>
        </div>

        {/* Responsibilities */}
        <div className="mt-14">
          <h2 className="text-2xl font-bold text-trogoBlue">
            2️⃣ Company Responsibilities
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mt-6">

            {[
              "Protect sensitive customer information",
              "Maintain secure & verified platform",
              "Store only required essential data",
              "Customer satisfaction as primary goal",
              "Provide verified & reliable transport services",
              "Ensure only authorized drivers & vehicles",
              "Provide 24/7 customer support system",
              "Strict enforcement of company policies"
            ].map((item, index) => (
              <div key={index} className="bg-white shadow rounded-2xl p-6 border">
                <span className="text-trogoBlue font-bold text-body">
                  ✔ Responsibility {index+1}
                </span>
                <p className="text-gray-700 mt-3">
                  {item}
                </p>
              </div>
            ))}

          </div>
        </div>

        {/* Reserved Rights */}
        <div className="mt-14">
          <h2 className="text-2xl font-bold text-trogoBlue">
            3️⃣ Reserved Rights
          </h2>

          <div className="bg-white rounded-2xl shadow p-8 border mt-6 space-y-4">
            <p className="text-gray-700">
              To Goods Draft Private Limited reserves full rights to:
            </p>

            <ul className="space-y-2 text-gray-700">
              <li>➡ Establish & enforce company policies</li>
              <li>➡ Decide what data is necessary to store</li>
              <li>➡ Verify & register drivers and vehicles</li>
              <li>➡ Take strict legal or platform actions 
                against any policy violation</li>
            </ul>
          </div>
        </div>

        {/* Footer Note */}
        <div className="mt-14 bg-gradient-to-r from-trogoBlue to-trogoOrange text-white p-10 rounded-3xl shadow-lg text-center">
          <h3 className="text-2xl font-bold">Your Privacy, Our Priority</h3>
          <p className="mt-3 opacity-90">
            We are committed to ensuring trust, transparency and highest level
            of protection for every TROGO user.
          </p>
        </div>

      </div>
    </section>
  );
}
